
import * as moment from 'moment';
import { IUser } from 'src/modules/authentication/interfaces/user.interface';

export function getCompanyContent(user: IUser, companyName: string) {
    const contractSignedDateMoment =
        (typeof user['contract_signed'] !== 'undefined')
            ? moment(user.contract_signed) : moment(parseInt(user._id.toString().substring(0, 8), 16) * 1000);

    const dayEstAgree = contractSignedDateMoment.format('Do');
    const monthEstAgree = contractSignedDateMoment.format('MMMM');
    const dateStafferAgree = contractSignedDateMoment.year() +
        '/' + (contractSignedDateMoment.month() + 1) +
        '/' + contractSignedDateMoment.date();
    const year = contractSignedDateMoment.year();
    const isHospitalityClient = user.companyType === 'Hospitality';

    // For Hospitality users
    if (isHospitalityClient) {
        return [
            {
                text: 'Staffy Terms and Hospitality Addendum',
                style: 'header'
            },
            '\n\n',
            {
              "text": [
                {
                  "text": "Staffy Canada Inc. (the ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Company”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": ") operates a digital platform (the ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Platform”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": ") (available at www.staffy.com and through the Staffy mobile application) that connects healthcare, hospitality and other professionals (each such individual being a \"Professional\" as defined below) with enterprise Clients offering short-term working opportunities.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "Subject to the terms and conditions set forth in this Staffy Platform Services Agreement (together with any User Addendum incorporated herein by reference, the ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Agreement”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "), the Company makes the Platform available to User for access and use on a remote basis via the Internet, and provides various related content, functionality, products, and services, as may be made available through the Platform from time to time (collectively, the ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Platform Services”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": ").",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "This Agreement governs the User’s access to and use of the Platform Services.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " By clicking “ACCEPT”, or by otherwise accessing or using the Platform, User agrees with Company to be bound by this Agreement as either: (i) a Professional; or (ii) a Client (all capitalized terms as defined herein).  If an individual is agreeing to this Agreement on behalf of a corporation or other legal entity, such individual represents that he/she has the legal authority to bind such entity to this Agreement. ",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "1. DEFINITIONS",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "The following capitalized words and expressions have the following meanings unless otherwise expressly provided in this Agreement:",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Client”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means a Person who has registered for a Client Account on the Platform in accordance with this Agreement and who accesses or uses the Platform Services for the purpose of posting Shift Postings and hiring Professionals.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Client Account”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means a User Account for use by a Client.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Client Addendum”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means addendum that contains additional terms and conditions governing Client’s access to and use of the Platform Services, which may be incorporated into and made part of this Agreement, as applicable.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Client Content”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means any content uploaded, transferred, submitted or otherwise made available by Client to the Platform or Company, including Shift Postings and other materials relating to a Shift Posting provided by the Client.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Company Parties”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means Company, its affiliates, and their respective officers, directors, employees, agents, and any other parties working for or engaged by Company or otherwise involved in connection with the operation or administration of the Platform or the provision of Platform Services.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Company Privacy Policy”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means the Company’s privacy policy, available at: https://staffy.com/privacy-policy.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Contract Services”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means the services provided by Professional to Client in connection with a Shift Posting.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Documentation”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means any available user guides and other documentation relating to the Platform Services made available (regardless of form) by Company.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Login Credentials”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " has the meaning given to it in Section ‎2.2.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Hosting Provider”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " has the meaning given to it in Section ‎4.3.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Parties”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means the Company and the User that has entered into this Agreement, with each being referred to respectively as a ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Party”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " to this Agreement.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Person”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means an individual, a corporation, a partnership, a trust, an unincorporated organization, the government of a country or any political subdivision thereof, or any agency or department of any such government, and the executors, administrators or other legal representatives of an individual in such capacity.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Platform Enhancements”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means any and all improvements, modifications, upgrades and updates (including revisions, patches, improvements, modifications, enhancements, corrections and new releases) to the Platform Services, including those designed to improve the capabilities or performance of the Platform Services and third-party tools.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Platform Service Fee”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " has the meaning given to it in Section ‎6.2. For certainty, Platform Service Fees include any transaction fees or other fees charged by any third-party payment processors.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Professional”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means a Person who has registered for a Professional Account on the Platform in accordance with this Agreement and who accesses or uses the Platform Services for the purpose of responding to Shift Postings posted on the Platform by Clients and performing Contract Services for Clients.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Professional Account”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means a User Account for use by a Professional.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Professional Addendum”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means the addendum that contains additional terms and conditions governing Professional’s access to and use of the Platform Services, which may be incorporated into and made part of this Agreement, as applicable.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Professional Content”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means any content uploaded, transferred, submitted or otherwise made available by Professional to the Platform or Company, which may include biographic materials, profile photographs, and any other materials relating to Professional and Professional’s response to a Shift Posting.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Registration Information”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " has the meaning given to it in Section ‎2.1.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Shift”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means a scheduled period of time during which Professional is to provide the Contract Services to Client.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Shift Posting”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means a written description prepared by or on behalf of a Client for posting on the Platform, which describes the available Shift, Work Site, and scope of work required by the Client, and may include other information such as information that may be required by or prompted by the Platform.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Third Party Service”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " has the meaning given to it in Section ‎7.1.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Third Party Terms”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " has the meaning given to it in Section ‎7.1.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“User”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means the Professional or Client, as the context may indicate or require, that is agreeing to this Agreement.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“User Account”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " has the meaning given to it in Section ‎2.1.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“User Addendum”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means the Professional Addendum or the Client Addendum, as the context may indicate or require.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“User Content”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means Client Content or Professional Content, as the context may indicate or require.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "“Work Site”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means the location at which the Contract Services are to be performed, as requested by the Client.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "2. REGISTRATION",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "2.1 User Account.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "  In order to access the Platform and receive Platform Services, User must register on the Platform and create a unique user account by completing the relevant registration forms prompted by the Platform (the ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“User Account”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": ").  User will need to register for a Client Account if User agrees to be bound by this Agreement as a Client, and User will need to register for a Professional Account if User agrees to be bound by this Agreement as a Professional, in each case as prompted by the Platform.  User is responsible to provide true, accurate, current, and complete information as prompted by the registration forms (",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Registration Information”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "), including contact, payment, and billing information, as applicable, and User shall maintain and update such information to ensure that it is true, accurate, current, and complete at all times.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "2.2 Account Security.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Each User Account requires a name, email address, and password (the ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Login Credentials”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "). Login Credentials may also include other security and authentication information used by the Platform. User is responsible for maintaining the confidentiality of User’s Login Credentials and for all activities that occur under such Login Credentials. User may not: (a) disclose User’s Login Credentials to anyone else, or (b) attempt to gain control of or use any other person’s Login Credentials. User shall immediately change User’s password and notify Company if User’s Login Credentials are compromised in any way (including upon becoming aware that there has been any unauthorized access or use of the User’s User Account or Login Credentials, or that there has been any other breach of security related to a User Account). Company will not have any liability to User for any use or transaction made using User’s Login Credentials or User Account (whether or not authorized by the User), and Company will not be liable for any loss or damage arising from User failure to comply with this Section ‎2.2.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "2.3 Additional Terms.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " If User is a Professional, then the Professional Addendum (which includes additional terms and conditions governing Professional’s access to and use of the Platform Services) will apply. If User is a Client, then the Client Addendum (which includes additional terms and conditions governing Client’s access to and use of the Platform Services) will apply. The applicable User Addendum is incorporated into and made part of this Agreement.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "3. PERMITTED USE",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "3.1 Permitted Use.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Subject to User’s compliance with this Agreement, Company hereby authorizes User to access the Platform and make use of the Platform Services solely for the purposes described in the applicable User Addendum and in accordance with this Agreement.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "3.2 Responsibilities.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User: (a) is responsible for all activity it conducts using the Platform Services; (b) shall comply with all applicable laws relating to its use of the Platform Services; (c) shall comply with all policies adopted by Company and posted on the Platform from time to time regarding the Platform Services; and (d) shall provide all equipment necessary to establish a connection to the Internet, access to the Internet, and any telephone, wireless or other connection and service fees associated with such access.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "3.3 Restrictions.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " In accessing and using the Platform Services, User shall not:",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(a) make any modifications or enhancements to the Platform, or create any derivative work based on the Platform;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(b) remove any proprietary notices and notations in or on the Platform that refer to the confidentiality of or the intellectual property rights of Company or Company’s licensors;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(c) interfere or attempt to interfere with the proper workings or security or integrity of the Platform;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(d) attempt to gain unauthorized access to any part of the Platform other than those parts of the Platform to which User has been given express permission by Company;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(e) transmit any unwanted communications through or using the Platform Services, including any advertising, bulk email, solicitations, spam, or any unlawful, threatening, abusive, defamatory, obscene, sexually explicit, or profane materials;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(f) transmit any virus, malware, or other harmful data or code through or using the Platform Services;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(g) use or attempt to use the Platform for any illegal purposes or otherwise in any manner not contemplated by the Documentation;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(h) infringe any intellectual or proprietary rights of Company any other party;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(i) access or use the Platform Services in any way which may disrupt or impair: (i) the functionality of the Platform, (ii) the use of the Platform by Company or any other Person, or (iii) any systems used for the Platform Services; or ",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(j) decompile, disassemble, reverse engineer or otherwise attempt to reconstruct or discover the source code, design, or underlying programming sequences, methodologies and techniques of any component of the Platform except to the extent permitted by applicable law.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "3.4 Warranties and Representations.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User represents and warrants that:",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(a) User has the legal capacity and rights, power and authority, and all necessary consents and approvals, to execute, deliver and perform all of its obligations under this Agreement and without the payment of any fees, royalties or other amounts to any other person;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(b) User is, if an individual, of the legal age of majority under applicable law to form binding contracts with other persons and entities, and, if not an individual, User has legal capacity to form binding contracts with other persons and entities;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(c) none of the authorization, creation, execution or delivery of this Agreement nor compliance with or performance of the terms and conditions of this Agreement (including the licenses and assignments made herein) has resulted in or will result in a breach of, or constitute a default under, any agreement, understanding, undertaking or instrument (including, if User is a corporation, its articles, by-laws or other constituting documents and any resolutions passed by its board of directors or shareholders) to which it is a party or by which it or its property is or may be bound;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(d) the performance or receipt of the Contract Services, as applicable, will not violate or infringe any third party rights nor give rise to any third party claims and is provided in compliance with all applicable laws, regulations, regulatory guidelines, policies and codes and industry guidelines, policies and codes; and",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(e) it has and it will comply with all applicable laws and regulations in the performance of this Agreement and its obligations hereunder.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "3.5 Suspension.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Company reserves the right, at its sole discretion, to suspend, with or without notice to User, User’s access to any (or all) Platform Services if Company reasonably determines that User is in breach of this Agreement or otherwise engaging in acts contrary to the policies of Company or any Documentation. For certainty, such suspension does not affect either Party’s rights and obligations accrued prior to such suspension (including with respect to Contract Services provided by or to User prior to such suspension). ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "4. THE PLATFORM AND PLATFORM SERVICES",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "4.1 Availability.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " The Platform is intended to be generally available seven days per week, 24 hours per day, except for downtime for system maintenance and other reasons beyond Company’s control. Company does not guarantee or warrant that all or any portion of the Platform will be accessible at all times, or that User Content will be backed up or can be accessed at all times. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "4.2 Security.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Company has implemented security policies and practices that are designed to protect the security and integrity of the Platform. However, no data transmission over the Internet or other communication network or systems can be guaranteed to be secure, and there is always risk that an unauthorized third party could thwart the security measures that the Company has implemented, including by intercepting transmissions. COMPANY DOES NOT GUARANTEE THE SECURITY OF COMMUNICATIONS AND DATA PROVIDED OR TRANSMITTED THROUGH THE PLATFORM.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "4.3 Hosting Provider.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User acknowledges and agrees that Company (or its licensors) may operate the Platform, provide the Platform Services, and store content and data (including User Content) using services, infrastructure, and software provided by third parties (",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Hosting Providers”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "), which may be located in a jurisdiction outside of the jurisdiction in which User resides. User shall comply with any policies and terms of any Hosting Provider that are applicable to User and of which Company provides User with notice.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "4.4 Changes.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Company reserves the right to suspend, modify or update the Platform Services (or any part thereof) at any time in Company’s sole discretion without notice to User (including to change or reduce or eliminate any features or functionalities of the Platform). Company does not guarantee continued compatibility with any Third Party Service.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "4.5 Nature of the Platform Services.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User acknowledges and agrees that in providing the Platform Services, Company merely provides a digital tool to assist: (a) Clients to create and publicize Shift Postings for the purpose of procuring Contract Services; and (b) Professionals to respond to Shift Postings and provide Contract Services. User expressly acknowledges and agrees that: (i) Company is not a placement agency; and (ii) in providing Contract Services, Professionals will be acting at all times as independent contractors of the applicable Client, and not as employees of the Company or the Client for any purpose whatsoever.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "4.6 Ownership.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " All right, title, and interest, including all intellectual property rights, in and to the Platform, Platform Services, and Platform Enhancements (including any solution enhancements created using any feedback or suggestion provided by User) are, and will be, owned solely and exclusively by Company or its licensors, as applicable. Except for the limited rights to use the Platform Services expressly provided to User under this Agreement, Company reserves all rights in and to the Platform Services and no implied rights or licenses are granted.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "5. USER CONTENT",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "5.1 Ownership and License.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User retains ownership of any User Content, and intellectual property rights in and to the User Content, provided by User to Company or submitted by User to the Platform. Each User hereby grants to Company (and any third party authorized by Company) an irrevocable, perpetual, worldwide, unrestricted, fully paid up, royalty free, non-exclusive right and license to store, reproduce, publish, display, disclose, transmit, modify, and otherwise use and process User Content (in whole or in part, as is or as may be modified) and any materials based on or derived from User Content for the purpose of providing the Platform Services, facilitating User’s access to and use of the Platform Services, and advertising and promoting the Company and Company’s products and services. User hereby waives all moral rights (and all other rights of a like or similar nature) that User may have in the User Content. For certainty, Company may publicly identify User as a customer of Company, and use any logos or trademarks provided by User to Company, in connection with Company’s advertising and promotional activities.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "5.2 Responsibility for User Content.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User acknowledges that Company does not independently evaluate, investigate, or otherwise conduct any due diligence regarding any User Content provided by Clients or Professionals, and Company has no liability to User for any damage or loss concerning the accuracy of any User Content or User’s access to, or use of, or reliance on, any User Content (whether User Content of the User or of another Client/Professional). All User Content is the sole responsibility of the User from whom such User Content originated. Company disclaims any and all liability relating to User Content. All User Content is used by User at its own discretion and sole risk.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "5.3 User Content Details.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User represents and warrants that all User Content provided to Company or made available to and through the Platform by User is: (a) true, accurate and current; (b) does not and will not, directly or indirectly, infringe, violate or breach any duty toward or rights of any person or entity, including without limitation any copyright, trademark, service mark, trade secret, other intellectual property, publicity or privacy right; and (c) provided in compliance with all applicable laws, regulations, regulatory guidelines, policies and codes and industry guidelines, policies and codes.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "5.4 Use of User Content by Third Parties.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User acknowledges that certain User Content provided to Company or submitted to the Platform (such as Shift Postings and Professional biographical details) may be accessible by other Clients and Professionals, and Company cannot guarantee that any further dissemination of User Content will be subject to Company’s control. User hereby releases Company from any and all liability related to the dissemination, reproduction, distribution, display or use of User Content by a third party.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "5.5 Right to Remove or Refuse Content.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Company reserves the right to remove or decline to post to the Platform any User Content that violates the terms of the Agreement or for any other reason that the Company determines, in its sole discretion, including that such User Content presents a business, legal, or security risk to Company, other Users or any other Persons. Company will not be liable for any damages arising from Company’s removal of any User Content or Company’s refusal to post any User Content. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "6. FEES AND PAYMENT",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "6.1 Payment for Contract Services.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " If User is a Professional, then User will invoice Company and be paid in accordance with the Professional Addendum. If User is a Client, then User will receive invoices from Company (on behalf of the Professional/Professionals providing Contract Services to that User) and will pay for Contract Services in accordance with the Client Addendum.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "6.2 Platform Service Fees.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Company (and providers of Third Party Services, where applicable) may impose a transaction charge, use fee, or other amount in respect of certain Platform Services (",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Platform Service Fees”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "). Platform Service Fees may be set out in the applicable User Addendum, or may otherwise be disclosed to User through the Platform. Where applicable, Company may deduct such Platform Service Fees from amounts otherwise payable to User, include such Platform Service Fees in or with fees otherwise payable by User, or separately invoice User for such Platform Service Fees. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "6.3 Payment Processing.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Company may use a third-party payment processor. The processing of payments in connection with the use of the Platform Services will be subject to the terms, conditions, and privacy policies of the payment processor (and where applicable, payment card issuer). Company is not responsible for any errors by the payment processor and User shall resolve any disputes for amounts charged (or paid/not paid) directly with the payment processor. In connection with User’s use of the Platform Services, Company will obtain certain transaction details, which Company will use solely in accordance with the data processing and privacy terms of this Agreement and the Company Privacy Policy. User will be responsible to obtain all necessary authorizations and consents to process User credit cards and other permitted payment cards and methods.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "6.4 Taxes.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Company’s fees are exclusive of any applicable taxes which may be assessed by any governmental authority having jurisdiction. User will pay to Company or, if required by the Company or by the governmental authority, to the applicable governmental authority the amount of any applicable taxes levied based on the User’s performance of its obligations and exercise of its rights under this Agreement. If any taxes are withheld and paid to a governmental authority, User will increase the amount of fees paid to Company in respect of the withheld amounts so that Company receives and retains the full amount owing from User. Company is responsible for taxes assessable against it based on its income.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "7. THIRD PARTY SERVICES",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "7.1 Third Party Terms.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " The Platform may include features or links that direct User to, or allow User to access, use, or interact with, third party websites, applications, content, products, and services (",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Third Party Services”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "). When User accesses, uses, or interacts with any Third Party Service, their own terms and privacy policies (",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Third Party Terms”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "), in addition to this Agreement, as applicable, will apply. If there is any inconsistency between this Agreement and such Third Party Terms, then the applicable Third Party Terms will apply to such Third Party Services to the extent of the inconsistency. User is solely responsible for all fees, charges, and expenses associated with any Third Party Services. To the extent that User elects to access, use or interacts with any Third Party Services, User authorizes Company to disclose User Content and other information provided by the User (including financial information and personal information) to the applicable third party for the purpose of facilitating User’s access to, use of, or interaction with such Third Party Services.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "7.2 No Liability for Third Party Services.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " All Third Party Services are used by User on an ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“as-is”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " basis, and User accesses, uses, or interacts with such Third Party Services at User’s sole risk. Company will have no liability to User for any damage or loss in connection with User’s access to, use of, or interaction with, any Third Party Services (including with respect to any unauthorized disclosure, use, or loss of any User Content or other information provided by the User). User hereby irrevocably releases Company and other Company Parties from any and all claims and liabilities associated with User’s access to, use of, or interaction with, any Third Party Services.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "8. PRIVACY POLICIES",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "The collection, use, and disclosure of personal information in connection with User’s access to and use of the Platform Services will be subject to and governed by the Company Privacy Policy, which is incorporated into and made part of this Agreement by reference. User is responsible for its compliance with all applicable privacy laws, and User confirms that all personal information provided by User to Company or submitted to the Platform have been provided in compliance with all applicable laws.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "9. DISCLAIMER",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "The Platform and Platform Services are provided on an ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“as is”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " and ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“as available”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " basis and at User’s own risk. Except as expressly set forth in this Agreement, Company makes no representations or warranties of any kind or nature, whether express or implied, and Company expressly disclaims, to the full extent permissible under applicable law, any and all warranties and conditions of any kind, including without limitation: (a) fitness for a particular purpose; (b) non-infringement of third party rights; (c) that the Platform Services will always be available, accessible, uninterrupted, timely, secure, free of malicious code or virus, or operate without error; (d) that any errors can or will be corrected. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "10. RISK MANAGEMENT",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "10.1 Limitations and Exclusions.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " To the maximum extent permitted by law, in no event will Company be liable to User or any third party for any indirect, special, incidental, consequential, or punitive damages however caused, whether in contract, tort or under any other theory of liability or for any other damages, including loss of revenue or profits, loss of, or damage to, reputation, indirectly arising out of or related to this Agreement (including any User Addendum), the Platform or Platform Services, any User Content, or any Contract Services, whether or not such damages could reasonably be foreseen or their likelihood has been disclosed to Company. In no event shall Company’s total aggregate liability arising out of or related to this Agreement (including any User Addendum), the Platform or Platform Services, any User Content, or any Contract Services, whether in contract, tort or under any other theory of liability, exceed the Platform Service Fees paid by the User (where the User is a Client) or the Platform Service Fees collected by Company in respect of User’s use of the Platform (where the User is a Professional), during the three month period immediately preceding the date on which the cause of action arose.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "10.2 Limitations Apply.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User acknowledges that in entering into this Agreement and setting the fees Company has relied on the limitations and exclusions of liability set forth in this Agreement as a fundamental and essential part of the Parties’ agreement. Accordingly, the limitations and exclusions set forth in this Agreement apply irrespective of the cause of action, demand or claim or theory of liability, including an action, in contract, negligence, tort, by statute or otherwise, and shall survive breaches and/or the failure of the essential purpose of this Agreement.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "10.3 Limitation Period.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " No action arising out of or in connection with this Agreement may be brought by User more than one year after the date on which the cause of action has accrued.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "11. INDEMNIFICATION",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "User shall defend, indemnify and hold harmless Company and the Company Parties from and against any and all claims, damages, liabilities, losses, costs and expenses (including legal expenses, fines, fees and the cost of investigation and resolution), arising out of, relating to or in any connection with any claim, action, suit or proceeding by, or settlement with, any third party (including another User) based on, or arising as a result of: (a) User’s breach of any warranty, representation, grant, license or waiver of rights or agreement made in this Agreement; or (b) any User Content provided or submitted by User. ",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "12. MUTUAL AGREEMENT TO ARBITRATE DISPUTES (",
                  "fontSize": 16,
                  "bold": true,
                  "style": [
                    "html-h1",
                    "para-heading"
                  ]
                },
                {
                  "text": "“ARBITRATION PROVISION”",
                  "nodeName": "B",
                  "fontSize": 16,
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-h1",
                    "para-heading"
                  ]
                },
                {
                  "text": ")",
                  "fontSize": 16,
                  "bold": true,
                  "style": [
                    "html-h1",
                    "para-heading"
                  ]
                }
              ],
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "12.1 Agreement to Arbitrate",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "(a) If any dispute, disagreement, claim or difference arises out of or relating to this Agreement or the Contract Services between the Company and the User, or the User and the Company or any Company Parties (a ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Dispute”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "), the Party raising the Dispute shall promptly provide written notice to the other Party. The Parties agree to first attempt to resolve any disputes or claims amicably through discussion between the Parties. If the Parties are unable to reach a resolution amicably within 30 days of the delivery of a Dispute Notice by one Party on the other Party, and except as provided explicitly in Section ‎12.7, the Parties hereby agree that, to the fullest extent permitted by law, any and all disputes or claims between User and Company, whether in contract, tort, or otherwise arising out of or in any way relating to this Agreement, the Platform Services, the Contract Services, or the relationship between the Parties, including but not limited to any disputes or claims regarding the formation (including any assertion of unconscionability or invalidity), existence, breach, termination, services, scope, validity, enforceability, applicability, or interpretation of the relationship between the Parties or this Agreement, shall be exclusively resolved by final and binding arbitration. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(b) For additional clarity, by agreeing to this Agreement, User hereby expressly waives, to the extent permitted by applicable law, their right to have any dispute or claim resolved by a court, unless specifically set out herein.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "12.2 Arbitration Procedures and Location.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " All Disputes will be finally resolved by arbitration before a single arbitrator under the Simplified Arbitration Rules of the ADR Institute of Canada, Inc. (the ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“ADRIC Simplified Rules”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": ", and the ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Institute”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": ", respectively), except that the Parties will ask the Institute to deliver to all parties a list of at least three individuals from which the parties may agree to select an arbitrator. If the Parties do not agree to select an arbitrator within 14 days of receipt of the list from the Institute, the arbitrator will be appointed by the Institute in accordance with the ADRIC Simplified Rules.  The Seat of Arbitration (as defined in the ADRIC Simplified Rules) will be Toronto, Ontario. Unless the parties otherwise agree or the arbitrator orders otherwise, the location of evidentiary or other arbitration hearings shall be the province where the User is performing or receiving Contract Services and in the city that is geographically closest to where the User is located in the province that has a population greater than 100,000; provided that in the event that there is no such city in the province, hearings will be held: (i) in such location as the parties may mutually agree to, or (ii) in the absence of such agreement, the provincial capital. The language of the arbitration will be English.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "12.3 Arbitration Costs, Lawyers’ Fees, and Costs.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " The arbitrator shall have the power to award and apportion the arbitration costs (including the arbitrator’s fees and expenses) in accordance with the ADRIC Simplified Rules. Each Party shall otherwise pay its own lawyers’ fees and costs. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "12.4 Awards.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " The arbitrator is authorized to award any remedy or relief available under applicable law that the arbitrator deems just and equitable, including any remedy or relief that would have been available to the parties had the matter been heard in a court. The decision of the arbitrator shall be in writing and shall provide the reasons for the award unless the parties agree otherwise.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "12.5 Waiver of Class Action Claims.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User and Company hereby agree that each Party may bring and pursue claims against the other Party (or in the case of User, against any Company Parties) only in their individual capacities, and may not bring, pursue, or act as a plaintiff, class representative, or class member in any purported class or collective proceeding or action other than on an individual basis except to the extent this provision is unenforceable as a matter of law. Notwithstanding any other provision in this Agreement, if the waiver set forth in this Section ‎12.5 is found to be unenforceable, the Parties agree that any class or collective action claims will be litigated in a court of competent jurisdiction and not as a class or collective arbitration.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "12.6 Waiver of Other Representative Proceedings and Jury Trial.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(a) The Parties hereby agree that, to the extent permitted by applicable law, any and all dispute resolution proceedings will be conducted only on an individual basis and not in a collective, consolidated, or on the basis of a joinder of proceedings.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(b) If for any reason a dispute, claim, or controversy proceeds in a court rather than in arbitration, to the extent permitted by applicable law, the Parties hereby further waive any right to a jury trial and agree that any such court proceeding will also be conducted only on an individual basis and not in a class, representative, collective, consolidated, or on the basis of a joinder of proceedings.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "12.7 Claims Not Covered.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Disputes or claims between Company and any third party beneficiaries are also not covered by the terms of this Arbitration Provision. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "13. TERM AND TERMINATION",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "13.1 Term.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " This Agreement shall become effective at the time User accepts this Agreement and shall apply for the duration of time that User uses the Platform Services, or for any specific term or period to which a User subscribes, unless earlier terminated by either Party as permitted by this Agreement. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "13.2 Renewal.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " If User has subscribed for a specific term or period (e.g. annual or monthly or on some other basis), then at the end of each such period, this Agreement will be automatically renewed for a period of time of the same duration as the immediately preceding term or period.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "13.3 Termination – Particular Events.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Company may immediately terminate this Agreement or, without limiting its other rights and remedies, suspend, User’s access to the Platform Services without notice upon the occurrence of any of the following events: (a) User fails to make any payments when due; (b) User fails to comply with any provision of this Agreement; or (c) User files an assignment in bankruptcy or is or becomes bankrupt or insolvent, upon the appointment of a receiver for all or substantially all of the property or assets of the User, upon the making of any assignment or attempted assignment for the benefit of creditors or on the institution by User of any act or proceeding for the winding up of its business. If Company terminates or suspends the User’s access to the Platform Services or this Agreement under this Section, User understands and agrees that User will not receive a refund of, or credit for, any fees paid. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "13.4 Other Termination.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Company reserves the right to terminate this Agreement or suspend or terminate User’s access to the Platform Services (or any part of the Platform Services): (a) upon five days’ notice to User for any reason whatsoever; or (b) immediately, if User does not agree to accept an amended version of this Agreement as amended in accordance with Section 14. In the event that Company terminates or suspends the User’s access to the Platform Services or this Agreement under this Section ‎13.4, User will receive a pro-rata refund of any prepaid fees paid to Company for which Platform Services have not been provided. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "13.5 Termination by Users.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User may cease to use the Platform Services at any time subject to the terms of this Agreement concerning the payment of fees.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "13.6 Effects of Termination.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " In the event of a termination of the Agreement:",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(a) Company shall cease providing the Platform Services, and User’s access to the Platform and Platform Services shall terminate;  ",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(b) User will remain obligated to make any payments due hereunder which remain unpaid; ",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(c) Company will provide the User with 30 days to retrieve any User Content it has submitted to the Platform; and",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(d) Company may (but has no obligation to) remove any User Content and delete any User information or related details.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "Termination of this Agreement will not affect any Party’s accrued rights or liabilities. Company will not be responsible or liable to User for User’s inability to access or use any User Content or any other portion of the Platform after termination of this Agreement.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "13.7 Survival.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " The following Sections of this Agreement, and such other terms as are necessary to give effect to the surviving terms, will survive any termination of this Agreement: ‎3.4, ‎4.5, ‎4.6, ‎5, ‎6 (with respect to any outstanding payment), ‎7, ‎8, ‎9, ‎10, ‎12, ‎13.5, ‎13.6, and ‎15.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "14. Amendments",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "Company may amend this Agreement at any time. The most current version of this Agreement will always be posted on the Platform and prior versions will remain available for review. If the terms of this Agreement are revised, Users will be required to agree to the updated Agreement the next time the User logs in to the Platform. Unless otherwise agreed to between User and Company, if User does not agree to the revised Agreement, User will not be permitted to continue accessing the Platform and using the Platform Services. This Agreement may also be amended by a separate written document that is made in writing, dated and executed by the Parties. This Agreement cannot otherwise be amended or modified. ",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "15. General Provisions",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.1 Notice.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " All required notices, or notices which may be provided in accordance with this Agreement, shall be in writing and shall be duly provided for if the notice is remitted to its addressee by pre-paid courier, registered or certified mail, or e-mail, if to Company to the address listed on the contact portion of the Platform, and if to the User to the address set out on its profile included in the Registration Information. Every notice delivered in the manner provided for herein shall be deemed to have been received: when delivered or if by e-mail the first business day after the date received unless the sender receives a notice of delivery failure in which case another permitted method of notice will be used.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.2 Compliance with Laws.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " User is solely responsible for complying with, and User shall comply with, all applicable laws in connection with User’s access to and use of the Platform Services. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.3 Entire Agreement.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " This Agreement (including, for certainty, the applicable User Addendum) contains the complete and exclusive statement of the agreement between the Parties relating to the subject matter of this Agreement, and supersedes all prior and contemporaneous agreements, purchase orders, understandings, proposals, negotiations, representations, or warranties of any kind whether written or oral. No oral or written representation between the Parties that is not expressly contained in or explicitly provided for by this Agreement is binding on either Party.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.4 Governing Law.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " This Agreement will be interpreted in accordance with and governed by the laws of the Province of Ontario, Canada, without regard to any conflict of law principles that would cause the application of any other law. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.5 Assignment.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " This Agreement will be binding upon and will enure to the benefit of and be enforceable by each of the Parties hereto, their respective successors and permitted assigns. User may not assign, delegate or transfer all or any part of this Agreement (or any of User’s rights or obligations) without the prior consent of Company. Company may assign this Agreement without User’s consent at any time. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.6 Relationship.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " This Agreement is not to be construed as creating any partnership, agency (except as expressly provided) relationship, employment relationship or any other form of legal association or entity that would impose liability upon one Party for the actions or failure of the other. For greater certainty, the Parties are independent contractors.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.7 Waiver.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Failure to exercise or enforce any right or provision shall not affect Company’s right to exercise or enforce such right or provision at any time thereafter, nor shall a waiver of any breach or default of this Agreement constitute a waiver of any subsequent breach or default or a waiver of the provision itself. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.8 Severability.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " If any provision of the Agreement is held by a court of competent jurisdiction to be invalid or unenforceable in any respect, then the remaining provisions of the Agreement, or the application of such provisions to persons or circumstances other than those as to which it is invalid or unenforceable shall not be affected thereby, and each such provision of the Agreement shall be valid and enforceable to the extent granted by law.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.9 Currency.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " All amounts referred to in this Agreement are expressed in Canadian dollars, unless specifically indicated otherwise.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.10 Force Majeure.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Company shall not be liable for any failures or delay in the performance of its obligations hereunder caused by an event beyond its reasonable control, including acts of God, User’s acts or omissions, third party product or service failures, Internet or telecommunications outages, acts of civil or military authorities, fire, strikes, power surges or outages, pandemics, epidemics, flood, earthquakes, riot, or war. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.11 Interpretation.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " In this Agreement: (a) the division of this Agreement into Sections and the insertion of headings are for convenience of reference only and will not affect the construction or interpretation of this Agreement; (b) ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“including”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“including without limitation”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": ", and ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“includes”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " means ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“includes, without limitation”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "; (c) unless the context requires otherwise, words importing the singular include the plural and vice versa, and words importing gender include all genders; (d) if any payment is required to be made or other action is required to be taken pursuant to this Agreement on a day which is not a business day, then such payment or action will be made or taken on the next business day; (e) any reference in this Agreement to any statute or any section thereof will, unless otherwise expressly stated, be deemed to be a reference to such statute or section as amended, restated or re-enacted from time to time; (f) all Company stated rights and remedies are not exclusive and are in addition to any other available rights and remedies.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "15.12 English Language.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " The parties have expressly required that this Agreement and all related documents, including notices and other communications, be drawn up in English exclusively. Les parties ont expressément exigé à ce que la présente convention ainsi que tous les documents qui s'y rattachent, incluant les avis et autres communications, soient rédigés en anglais exclusivement. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "HOSPITALITY Client Addendum ",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "This Client Addendum (",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Addendum”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": ") is incorporated into and made part of the Staffy Platform Services Agreement (the ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Agreement”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "), which governs Client’s access to and use of the Platform Services. For certainty, references to the Agreement also refer to this Addendum. In the event of any conflict between this Addendum and the body of the Agreement, this Addendum applies to the extent of the conflict. Capitalized terms used but not defined in this Addendum have the meanings described in the body of the Agreement. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "1. PERMITTED USE",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "1.1 Permitted Use.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Client may access and use the Platform Services solely for the purpose of: (a) creating and transmitting Shift Postings to the Platform; (b) reviewing Professionals' offers to provide Contract Services made in response to Shift Postings; (c) coordinating and agreeing with applicable Professionals regarding the provision of Contract Services; (d) making payment for Contract Services; (e) any other use of the Platform Services explicitly permitted by the Company to further the Client's business interests, including, in particular, the assembly or transmission of Client Content on the Platform and the use of the Platform's rating system; all in accordance with the terms and conditions set forth in this Addendum and elsewhere in the Agreement.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "2. CONTRACT SERVICES",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "2.1 Shift Postings.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Client may use the Platform functionality to: (a) create and transmit Shift Postings, which may be viewed by Professionals accessing the Platform; and (b) review offers submitted by Professional to Client in response to Shift Postings. If Client elects to engage a Professional to provide Contract Services in respect of a Shift Posting, then Client and Professional will coordinate via the Platform to confirm the Contract Services to be completed by Professional, and other related details; a Shift confirmation notice (",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Shift Confirmation Notice”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": ") will be generated by the Platform to evidence Professional and Client’s mutual agreement to the Contract Services to be performed, the start and end times for providing those Contract Services, the Professional’s rates and payment for the Contract Services, and other applicable terms. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "2.2 Evaluating Professionals.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(a) Unless otherwise agreed to between Company and Client, Client shall be responsible for preparing and posting Client’s own Shift Postings. Company makes no representations or guarantees regarding the suitability of any Professional for any Shift Posting or the accuracy of any information provided by or about any Professional, including through the Platform’s rating system or otherwise.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(b) Notwithstanding Section ‎2.2(a) of this Addendum, if requested by the Client, Company may request applicable Professionals to provide the results of, or submit to, background checks or other screenings, and Company will share the results of such background checks or screenings (to the extent they are available to Company) to Client to assist Client in the evaluation of Professionals. Where applicable, background checks and screenings may be conducted by third parties authorized by Company, and may be subject to additional terms and conditions; the Company Privacy Policy will govern with respect to any personal information provided by Professional in response to such screening. ",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "2.3 Company’s Role.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Client acknowledges that, except to the extent expressly set out in this Agreement, or as otherwise agreed to pursuant to Section ‎5 of this Addendum, Company will not be involved in any aspect of the performance of or arranging for Contract Services. Client further acknowledges that Company will have no liability for Client’s use of or reliance on any Professional or any Contract Services nor for any acts or omissions of any Professional. All Contract Services are used by Client at its own risk. Client remains solely responsible for its own decision to accept or reject any offer by a Professional to provide Contract Services made in response to any Shift Posting (notwithstanding that Company may provide suggestions or display reviews or ratings of Professionals to Clients through the Platform).",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "2.4 Shifts and Cancellation.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Each Shift must be four hours or longer. If Client wishes to cancel an agreement to receive Contract Services for a Shift after a corresponding Shift Confirmation Notice has been generated, Client must notify Company at least 48 hours prior to the scheduled Start of such Shift in order to permit Company to reasonably communicate such cancellation to Professional, failing which Client shall pay Company a cancellation fee (",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Cancellation Fee”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": ") in an amount equal to a total of three hours multiplied by the agreed-to hourly rate of each Professional scheduled for such Shift whose agreement to provide Contract Services is being cancelled; provided, that if Client wishes to cancel three or more Shifts that have been scheduled for the same day, then Client must provide Company with at least seven calendar days' notice, failing which Client shall pay to Company Cancellation Fee in an amount equal to 50% of the total fees (including the Contract Services Fees and Platform Service Fees described in Section ‎6.1 of this Addendum below) that would have been payable by Client had the agreements to provide Contract Services in respect of the Shift not been cancelled. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "2.5 Additional Client Terms.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Client may upload additional contractual requirements, such as non-disclosure or other terms and conditions that the Client proposes to apply to the Shift Posting and the corresponding Contract Services (",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Additional Client Terms”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "). Client is solely responsible to: (a) confirm that Professionals have agreed to such Additional Client Terms in the manner required by Client; and (b) enforce such Additional Client Terms against Professionals. Client acknowledges and agrees that Company will have no liability whatsoever in connection with any breach of Additional Client Terms by any Professional or any losses, liabilities or expenses incurred by Client in connection with such Additional Client Terms or breaches thereof.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "2.6 Client Obligations.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " In receiving the Contract Services, Client shall:",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(a) provide and maintain the Work Site and Client’s equipment and systems, all in accordance with industry standards but commensurate with the Professional’s status as a professional service provider and independent contractor;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(b) provide Professional with a safe work environment, and provide information, training and safety equipment in compliance with applicable laws and in accordance with industry standards;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(c) exclude Professional from Client’s benefit plans, policies, and practices, and not make any offer or promise relating to Professional’s compensation or benefits;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(d) maintain appropriate insurance coverage with adequate limits of liability to cover the Client’s liabilities (which are exclusive of Company’s and Professional’s insurance coverages and are not for the benefit of Company or Professional);",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(e) comply with all applicable laws (which for certainty includes any policies, procedures, and rules implemented by any governmental authority having jurisdiction over the Client, Company, or Professional) relating to the performance of the Contract Services and the Client’s business; and",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(f) cooperate fully with Company, and provided additional information, as Company may request to assist Company in investigating and resolving any claims, complaints, or disputes involving or relating to any Professionals or Contract Services.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "3. INDEPENDENT CONTRACTOR RELATIONSHIP",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "Client acknowledges and agrees that, in performing the Contract Services, Professionals will be acting as independent contractors, and not as employees of the Client (or of the Company) for any purpose whatsoever, including, without limitation: for purposes relating to benefits, taxes, payments required by statute or any other withholdings or remittances to any governmental agency or authority, and control over how Professionals provide their respective Contract Services. Neither this Agreement, the relationship created between the Parties pursuant to this Agreement, nor any course of dealing between the Professional, Company, and any Client is intended to create, or shall create, an employment relationship, a joint venture, partnership or any similar relationship. Client acknowledges and agrees that Professionals have no authority to enter into or conclude any contract or to undertake any commitment or obligation for, in the name of or on behalf of Client.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "4. SUBCONTRACTING",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "Unless otherwise specified or agreed upon between Client and Professional (including, without limitation, further to any Additional Client Terms for specific Shift Postings), Client acknowledges and agrees that Professional is not prohibited from subcontracting its provision of Contract Services for Client to third parties or from otherwise hiring a replacement for the Professional with respect to the provision of any Contract Services that the Professional has agreed to provide to Client. In the event of any such subcontracting, Professional remains responsible for the provision of the Contract Services and remains bound by all terms of this Agreement in any way relating thereto. Further, Client acknowledges and agrees that Professional shall be solely liable for any benefits, taxes, payments, obligations, liabilities, expenses or costs, as required by applicable law and arising from the Professional’s subcontracting for the provision of Contract Services to third parties.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "5. ADDITIONAL COMPANY SERVICES",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "Notwithstanding any other term of this Agreement, Company and Client may agree separately to provide additional Platform Services and/or other services that Client wishes to procure from Company. ",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "6. PAYMENT",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "6.1 Fees.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Client shall pay Company the following fees with respect to Contract Services completed by each Professional:",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "(a) fees in an amount equal to the Professional’s rates multiplied by the length of the Shift(s) completed by the Professional, plus any additional amounts agreed to by the Professional and the Client and/or the Company, in each case as set out in the applicable Shift Confirmation Notices (collectively, the ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Contract Services Fees”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "); ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(b) Platform use charge (which Platform use charge will be deemed to be a Platform Service Fee under Section ‎6 of the Agreement) in an amount equal to: (i) 30% of the Contract Services Fees invoiced by the Company, where the Client is paying by credit card, or (ii) 40% of the Contract Services Fees invoiced by the Company, where the Client is paying by cheque or electronic funds transfer; ",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(c) any transaction fees or similar charges charged by Company’s third party payment processor; and",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(d) any Cancellation Fees incurred by Client in accordance with Section ‎2.4 of this Addendum.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "6.2 Payment to Professional.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Unless otherwise agreed to by the Parties, Company will be responsible to make payments to Professional, on behalf of Client, in respect of Contract Services performed by Professional.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "6.3 Invoicing.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Company will invoice Client in respect of any Contract Services on a weekly basis, within 10 calendar days after the end of each week, or on such other interval and term as the Company and Client may agree in writing.  Each invoice will set forth the Contract Services provided to Client in the relevant week or other agreed-upon interval, based on the invoices generated by the relevant Professionals through the Platform. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "6.4 Payment Terms.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " All invoices shall be due and paid by Client no later than 30 days after the date of the invoice. All invoiced amounts will be paid in full without deduction and the Client may not set-off or deduct any amounts. Unless otherwise agreed in writing, Client shall pay all amounts owed under this Agreement by credit card. Client is responsible for providing Company with correct and up-to-date credit card information as may be prompted by the Platform from time to time. Client hereby authorizes Company to charge the Client’s credit card for any payments that are due and owing to Company under this Agreement.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "6.5 Disputed Amounts.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Notwithstanding Section ‎12 of the Agreement, if the Client intends to dispute any invoiced amount, then Client must provide Company with written notification no later than 10 days after the date of the applicable invoice, identifying the amount in dispute and the basis of the dispute, failing which, Client will be deemed to have accepted the relevant invoice without reservation. If Client wishes to dispute any invoiced amount and to withhold payment from the relevant Professional, then Client shall resolve such dispute directly with the Professional. Company may, but has no obligation to, help facilitate the resolution of such dispute by cooperating with Client and Professional in their investigation and negotiations relating to the dispute.  If Client notifies Company of such dispute after Client has already paid Company the corresponding payment for the relevant Contract Services, but before Company has paid the corresponding payment to the applicable Professional, and Client does not subsequently notify Company within a reasonable time (and in any event within 15 days after Client first notifies Company of such dispute) that the dispute has been resolved in Professional’s favour, then Company will refund the disputed amount to Client (less any Platform Service Fees, which will not be refundable) and Company will have no further obligations in respect of the dispute.  If Client notifies Company of such dispute after Company has already paid the applicable Professional, then: (a) Client acknowledges that Company will have no obligation to facilitate, or assist Client in, the recovery of any disputed amounts from the Professional, and (b) unless otherwise agreed to by Company and Client, Client will be solely responsible for recovering any disputed amounts directly from the Professional. For certainty, Client may not withhold payment of any invoiced amounts pending the resolution of the dispute, and any payment not made by the applicable payment due date will bear interest as described in Section ‎6.6.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "6.6 Additional Payment Terms.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " Any payment not made by the applicable payment due date will bear interest calculated from the payment due date until payment is made at the rate of 3% of the outstanding balance per month (42.6% per annum). If a payment is more than 30 days past due, Company may suspend the Platform Services, without liability to the Client, until such amounts (plus applicable interest) are paid in full.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "7. INDEMNIFICATION",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "In addition to Client’s indemnification obligations set forth elsewhere in the Agreement, Client shall defend, indemnify and hold harmless Company and the Company Parties from and against any and all claims, damages, liabilities, losses, costs and expenses (including legal fees/expenses, fines, fees and the cost of investigation and resolution), arising out of, relating to or in any connection with any claim, action, suit or proceeding by, or settlement with, any third party (including any Professional) based on, or arising as a result of:",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(a) personal injury (including death) of any Professional or other person in respect of the performance of Contract Services;",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(b) Client’s gross negligence, willful misconduct, or fraud; ",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(c) failure by Client, or any person when acting on behalf of Client (including Professional) to comply with applicable law; or",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "(d) any breach by Professional of any Additional Client Terms (as described in Section ‎2.5 of this Addendum).",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "8. NON-SOLICITATION",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "8.1 Non-Solicitation of Professionals.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " With respect to any Professional that provides Contract Services to Client as contemplated by this Agreement, and except with Company’s express written consent, Client shall not, and shall not permit any of its affiliates to, directly or indirectly, solicit or hire, or attempt to solicit or hire, such Professional as an employee or an independent contractor, or otherwise procure or attempt to procure the services of such Professional other than through the Platform, within six months after the Professional has last provided Contract Services to the Client. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "8.2 Company Consent to Hire Professionals.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " If Company consents to Client’s hiring (directly or indirectly) of any Professional as contemplated in Section ‎8.1 of this Addendum, then prior to the completion of such hiring, and unless otherwise agreed between Company and Client, Client shall pay Company an additional fee in an amount equal to 100 hours multiplied by the Professional’s Hourly Rate. ",
                  "style": [
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": "“Hourly Rate”",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": ", with respect to a Professional, means the average hourly rate paid to the Professional in respect of Contract Services performed by the Professional in the preceding six months.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": [
                {
                  "text": "8.3 Liquidated Damages.",
                  "nodeName": "B",
                  "bold": true,
                  "style": [
                    "html-b",
                    "html-div",
                    "para"
                  ]
                },
                {
                  "text": " If Company breaches Section ‎8.1 of this Addendum, then such breach will constitute a material breach of this Agreement. In addition to Company’s right to terminate this Agreement in its sole discretion, Client shall be obligated to pay to Company an amount equal to 400 hours multiplied by the Hourly Rate of the Professional hired or solicited by Company in breach of Section ‎8.1 of this Addendum. Client agrees that this amount represents a fair, reasonable, and appropriate estimate of damages for such breach.",
                  "style": [
                    "html-div",
                    "para"
                  ]
                }
              ],
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "9. SURVIVAL",
              "nodeName": "H1",
              "fontSize": 16,
              "bold": true,
              "style": [
                "html-h1",
                "para-heading"
              ]
            },
            {
              "text": " ",
              "style": []
            },
            {
              "text": "In addition to any other provisions specifically identified as surviving termination of the Agreement, the following Sections of this Addendum, and such other terms as are necessary to give effect to the surviving terms, will survive any termination of this Addendum: ‎6 (with respect to any outstanding payments), ‎7, ‎8, and ‎9.",
              "nodeName": "DIV",
              "style": [
                "html-div",
                "para"
              ]
            },
            {
              "text": "      ",
              "style": []
            }
        ];
    }

    // //  For Canada users
    if (getStateAndCity(user.address.city).country == 'Canada' || findCountryFromState(user.address.province) === 'Canada') {
        return [{
            text: 'Staffy Canada Inc. - General Staffing Agreement ',
            style: 'header'
        },
            '\n\n',
        'This General Services Agreement (the "Agreement") is entered into on the day of ' + dayEstAgree + monthEstAgree + ' , ' + year + ' by and between Staffy Canada Inc., a corporation incorporated under the laws of Canada ("Staffy"), and ' + companyName + ', a corporation incorporated under the laws of Canada (the "Client").',
            '\n\n', {
            text: 'WHEREAS: ',
            style: 'bolder'
        },
            '\n',
            'A. Client operates a business requiring temporary staffing.',
            'B. Staffy   provides   a   platform   that permits Client to source resources, when and where possible, to help resolve   temporary   staffing   issues (the “StaffyApp”).',
            'C. Client desires Staffy to provide access to the Staffy App on an as needed basis.',
            '\n', {
            text: 'NOW THEREFORE, Client and Staffy hereby agree as follows: ',
            style: 'bolder'
        },
            '\n', {
            text: '1) Services.',
            style: 'bolder'
        },
            '\n',
            'Upon request by Client (a“Service   Request”)   Staffy   shall create   an   assignment   on   the StaffyApp which shall be filled by auser of the Staffy App who elects to take   such   assignment   (each,   a“Worker”).  A Service  Request shall include   Client’s   name,   the   service position required, approximate hoursof   work,   the   name   and   contact information for the contact person to which a reply to the Service Request is   to   be   sent,   and   the   name   and address of the facility to which the Worker   is   to   report.   All   Service Requests shall be submitted by emailor   SMS  (text),  or,  as  possible,  the StaffyApp.',
            '\n', {
            text: '2) Staffy\'s Duties and Responsibilities.',
            style: 'bolder'
        },
            '\n',
            ' Staffy Shall:',
            '\n',
            'a) use reasonable efforts to maintain a pool of qualified Workers capable of providing the services, ',
            '\n',
            'b)	use reasonable efforts to provide confirmation of receipt of a Service Request within 30 minutes of receiving such request from Client,',
            '\n',
            'c)	use reasonable efforts to provide notification of the assignment of a Worker to perform the services requested in a Service Request, within 2 hours of receiving a Service Request, subject to availability of a qualified Worker,',
            '\n',
            'd)	make reasonable efforts to provide replacement Workers in the event the assigned Worker does not report to or perform the work requested,',
            '\n',
            'e)	be responsible for paying Worker on the Client’s behalf, and',
            '\n',
            'f)	require each Worker to sign an agreement with Staffy, acknowledging that they are not entitled to vacation, vacation pay, severance or termination pay, notice or pay in lieu of notice, disability benefits, insurance, pensions, retirement plans, or any other benefits offered or provided by Client to its employees.',
            '\n',
            'g)	ensure any Registered Nurses or Registered Practical Nurses assigned as Workers are have a current and valid license and are registered in good standing with the College of Nurses.',
            '\n',
            'h)	ensure all Workers sign a Confidentiality Agreement with the Agency that prohibits them from disclosing any confidential information about the Client and its employees and/or residents.',
            '\n',
            'i)	ensure all Workers have completed a self attestation regarding necessary medical screening and/or immunizations (i.e. TB test, flu shot).',
            '\n',
            'j)	ensure that all clinical staff have the following:',
            '\n',
            'i) Professional credentials and certifications, including a copy of current registration with the applicable provincial licensing authority;',
            '\n',
            'ii) Clear Criminal Record Check; ',
            '\n',
            'iii) Current Vulnerable Sector Police Checks and/or Adult Abuse Registry Check; ',
            '\n',
            'iv) Medical Clearance i.e. TB tests, flu shots; and',
            '\n',
            'v) Current CPR Credential.',
            '\n',
            'k) Notwithstanding Sections 2(j) above, in consideration of the difficulty of satisfying these requirements during the COVID-19 pandemic, the Client acknowledges that for the duration of the COVID-19 health emergency a Worker will be allowed to commence work at a Home without having provided a copy of items 2(iii), (iv) and (v) prior to the start of the Worker’s first shift provided that the Worker will:',
            '\n',
            'i) complete a satisfactory Offence Self-Declaration Form (COVID-19) prior to his or her first shift;',
            '\n',
            'ii) complete item 2 (iii) as required, within six (6) weeks (or such shorter timeframe where possible) of his or her first shift; and',
            '\n',
            'iii) complete a Statement of Fitness including all applicable vaccinations and within 6 weeks of his or her first shift ',
            '\n',
            'l) provide the Client access to the Platform whereby they can review all the aforementioned documents as submitted by any Worker that has worked for the Client for a period of 6 months.',
            '\n', {
            text: '3) Client\'s Duties and Responsibilities:',
            style: 'bolder'
        },
            '\n',
            ' Client Shall:',
            '\n',
            'a) properly supervise the Worker performing its Work and be responsible for its business, operations, products, services and intellectual property,',
            '\n', 
        //     {
        //     style: ['quote', 'boldest'],
        //     table: {
        //         body: [
        //             ['Do you agree with above clause?', 'YES'],
        //         ]
        //     }
        // },
            '\n',
            'b)	properly supervise, control and safeguard its premises, processes, and systems,',
            '\n',
            'c)	provide Staff with a safe work environment and provide appropriate information, training and safety equipment, as appropriate,',
            '\n',
            'd)	not change assigned Worker’s jobduties without Staffy’s express prior written approval, ',
            '\n',
            'e)	exclude Worker from Client’s benefit plans, policies, and practices, and not make any offer or promise relating to Worker’s compensation or benefits,',
            '\n',
            'f) maintain appropriate insurance coverage withad equate limits of liability;',
            '\n',
            'g)	refrain from entrusting Worker with unattended premises, cash, checks, keys, credit cards, merchandise, confidential or trade secret information, negotiable instruments, or other valuables without Staffy’s express prior written approval or as strictly required by the job description provided to Staffy, and',
            '\n',
            'h)	refrain from using the services ofany Worker as its direct employee,as an independent contractor, orthrough any person or firm otherthan Staffy during or within 6months after the end of anyassignment of the Worker to Clientfrom Staffy, except with the priorwritten consent of Staffy and uponpayment of the fee described insection 4(i) below, and',
            '\n',
            'i)	Adhere to all reasonable policies, procedures and rules implemented by Governments and Regulating Bodies from time to time, including but not limited to all Long Term Care or Retirement Homes policies and procedures required by the LongTerm Care Homes Act or Retirement Homes Act, as applicable.',
            '\n',
        //      {
        //     style: ['quote', 'boldest'],
        //     table: {
        //         body: [
        //             ['Do you agree with above clause?', 'YES'],
        //         ]
        //     }
        // },
            '\n', {
            text: '4) Payment Terms, Bill Rates and Fees. ',
            style: 'bolder'
        },
            '\n',
            'a)	Client shall pay Staffy for all work completed by Worker (the“Completed Work”) in accordance with the rates agreed upon, and will pay any additional costs or fees set forth in this Agreement (cumulatively referred to as “MoniesOwed”).',
            '\n',
            'b)	Client shall pay Staffy an administrative fee of:',
            '\n\n',
            'i) 30% on the total amount charged for Completed Work if Monies Owed are processed asset out in paragraphs (c) and(d) below or 35% if alternative payment arrangements are negotiated; or',
            '\n\n',
            'ii) If Client agrees to an Preferred Relationship, as set out in Section   5,   then   the administrative fees shall be 20% on the total amount charged for Completed Work if Monies Owed are processed as set out in paragraphs (c) and (d) below, or 35% if alternative payment arrangements are negotiated.',
            '\n\n',
            // 'iii) 40% if alternative payment arrangements are negotiated.',
            // '\n\n',
            'c)	Client shall provide Staffy with a pre-authorized credit card to satisfy all Monies Owed to Staffy.',
            '\n', 
        //     {
        //     style: ['quote', 'boldest'],
        //     table: {
        //         body: [
        //             ['Do you agree with above clause?', 'YES'],
        //         ]
        //     }
        // },
            '\n',
            'd)	Staffy will charge all Monies Owed tothe Client’s credit card within 48 hours of the Completed Work and a receipt for the same will be issued (the “Receipt”).',
            '\n', 
        //     {
        //     style: ['quote', 'boldest'],
        //     table: {
        //         body: [
        //             ['Do you agree with above clause?', 'YES'],
        //         ]
        //     }
        // },
            '\n',
            'e)	Any discrepancy or dispute related to the Receipt must be conveyed within 48 hours of receiving the same.',
            '\n',
            'f) In the event the Monies Owed cannot be satisfied by the credit card provided, Staffy will contact the Client to provide another credit card. If another credit card is not immediately provided, or is provided and cannot satisfy the full amount of Monies Owed, the Client will be considered past due and a fee of 3% per month will be charged onthe full amount of the Monies Owed until they are paid.',
            '\n',
            'g) Monies Owed will be supported by pertinent time sheets or other agreed records documenting time worked by the Worker.',
            '\n',
            'h)	In the event Client fails to pay Monies Owed when due, or otherwise breaches its obligations under this Agreement, Staffy may, by notice, to Client suspend the provision of services to client until such time as the breach is remedied to Staffy’s reasonable satisfaction.',
            '\n',
            'i)	If Staffy consents to Client’s direct use of the services of any Staff as provided for in section 3(g) above, Client must pay Staffy an additional fee equal to 100 hours of service at the Staff’s regular hourly rate, or as otherwise negotiated.',
            '\n',
            'j)	Client’s failure to comply with section3(h) and/or the associated payment required by subsection (i) herein, shall constitute a breach of this Agreement and said breach will trigger a penalty, payable immediately upon such breach by Client to Staffy. Said penalty, which is in addition to the amounts due and owing under subsection (i) herein, shall be equal to 400 hours of service at the Worker’s regular hourly rate. In addition, upon such breach, Staffy reserves the right, in its sole discretion, to terminate or suspend the  delivery  of  services  under this Agreement. Client agrees that this penalty represents a fair, reasonable and appropriate estimate of damages.',
            '\n',
            'k)	In the event the Client wishes to hire a Worker, after the accumulation of 480 billed hours for that worker to the Client, no fee shall be required as payment to Staffy',
            '\n',
            'l)	If a pre-booked shift is cancelled within 48 hours of the shift start time, the Client may be subject to a three-hour cancellation fee.',
            '\n',
            'm)	If Client books more than 3 shifts at any one time, the Client shall provide 7 calendar days’ notice of cancellation of any and/or all shifts. Failure to provide such notice may subject Client to a cancellation fee equal to 50% of the Monies Owed had the shifts been completed.',
            '\n',
            'n)	The minimum length for any shift shall be 4 hours.',
            '\n', {
                text: '5) PREFERRED RELATIONSHIP',
                style: 'bolder'
            },
            '\n',
            'To the extent the Client selects the preferred option on the signature page, in exchange for the discounted fee structure set out in paragraph 4(b)(ii) herein, and subject to Section 11(c), Client agrees to use Staffy on an preferred basis for its temporary staffing needs for the Term of this Agreement (an “PreferredRelationship”)',
            '\n',
            {
                text: '6) Confidential Information. ',
                style: 'bolder'
            },
            '\n',
            'Staffy and Client may receive non-public information that is proprietary or confidential information to the other party or its affiliated companies and their clients. Both parties agree to hold such information in strict confidence and not to disclose such information to third parties or to use such information for any purpose whatsoever other than performing under this Agreement or as required by law. No knowledge, possession, oruse of Client’s confidential information will be imputed to Staffy as a result of Worker’s access to such information.',
            '\n', {
            text: '6) Nature of the Relationship. ',
            style: 'bolder'
        },
            '\n',
            'The relationship between Staffy and Client is that of an independent contractor. Nothing contained in this Agreement will be construed to create a relationship of partnership, principal and agent, or employer and employee, between Staffy and Client.',
            '\n', {
            text: '7) Marketing.',
            style: 'bolder'
        },
            '\n',
            'The client agrees to allow Staffy use of its logo, trade names and other service marks for purposes of cross-promotion and marketing',
            '\n', {
            text: '8) Cooperation.',
            style: 'bolder'
        },
            '\n',
            'Staffy and Client agree to cooperate fully and to provide assistance to the other party in the investigation and resolution of any complaints, claims, actions, or proceedings that may be brought by or that may involve Worker.',
            '\n', {
            text: '9) Indemnification and Limitation of Liability. ',
            style: 'bolder'
        },
            '\n',
            'a) To the maximum extent permitted by law, Staffy will defend, indemnify, and hold Client and its parent, subsidiaries, directors, officers, agents, representatives, and employees harmless from all claims, losses, and liabilities (including reasonable lawyers’ fees) to the extent caused by Staffy’s breach of this Agreement, or the gross negligence or willful misconduct of Staffy or Staffy’s officers, employees or authorized agents in the discharge of those duties and responsibilities.',
            '\n',
            'b)	To the maximum extent permitted bylaw, Client will defend, indemnify,and hold Staffy and its parent,subsidiaries, directors, officers,agents, representatives, andemployees harmless from all claims,losses, and liabilities (includingreasonable lawyers’ fees) to theextent caused by Client’s breach of this Agreement, or the negligence, gross negligence, or willful misconduct of Client or Client’sofficers, employees, or authorized agents in the discharge of those duties and responsibilities.',
            '\n',
            'c)	ALL WARRANTIES, CONDITIONS, REPRESENTATIONS, INDEMNITIES AND GUARANTEES, WHETHER EXPRESS OR IMPLIED, ARISING BYLAW, CUSTOM, PRIOR ORAL OR WRITTEN STATEMENTS BY STAFFY OR OTHERWISE (INCLUDING, BUT NOT LIMITED TO, ANY WARRANTY OF MERCHANT ABILITY OR FITNESS FOR PARTICULAR PURPOSE) ARE HEREBY OVERRIDDEN, EXCLUDED AND DISCLAIMED. STAFFY MAKES NO ASSURANCE AS TO THE RESULTS OF ITS SERVICES, AND STAFFY IS TO BE PAID FOR SERVICES RENDERED IRRESPECTIVE OF THE RESULTS OF SUCH SERVICES.',
            '\n',
            'd)	NEITHER PARTY SHALL BE LIABLE FOR OR BE REQUIRED TO INDEMNIFY THE OTHER PARTY FOR ANY INCIDENTAL, CONSEQUENTIAL, EXEMPLARY, SPECIAL, PUNITIVE, OR LOST PROFIT DAMAGES THAT ARISE IN CONNECTION WITH THIS AGREEMENT, REGARDLESS OF THE FORM OF ACTION (WHETHER IN CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, OR OTHERWISE) AND REGARDLESS OF HOW CHARACTERIZED, EVEN IF SUCH PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE MAXIMUM LIABILITY OF EITHER PARTY UNDER THIS AGREEMENT SHALL NOT EXCEED THE FEES PAID BY CLIENT UNDER THIS AGREEMENT DURING THE 5 DAY PERIOD PRECEDING THE OCCURRENCE OF THE EVENT GIVING RISE TO SUCH LIABILITY. ',
            '\n',
            'e)	As a condition precedent to indemnification, the party seeking indemnification will inform the other party within 2 business days after it receives notice of any claim, loss, liability, or demand for which it seeks indemnification from the other party; and   the   party   seeking indemnification will cooperate in the investigation and defense of any such matter.',
            '\n', {
            text: '10) Term of Agreement.',
            style: 'bolder'
        },
            '\n',
            'a) Subject to Section 11(c), this Agreement will be for a term of 12 months from the first date on which both parties have executed it (the“Initial Term”). Unless the Agreement is terminated pursuant to Section 11(b) or during the Initial Term, the parties mutually agree to renegotiate, the Agreement will be renewed automatically for an additional 12 month term (each a “Renewal Term” and, together with the Initial Term, the “Term”). Termination of this Agreement shall not be effective with respect to any placed Workers until their placements are terminated or cease.',
            '\n',
            'b) The Agreement may be terminated by either party upon 15 days’ written notice to the other party, except that if a party becomes bankrupt or insolvent, discontinues operations, or fails to make any payments as required by the Agreement, either party may terminate the agreement upon 72 hours written notice without penalty.',
            '\n',
            'c) Notwithstanding section 11(a), if Client agrees to an Preferred Relationship, the Initial Term shall be 24 months. Not withstanding anything to the contrary in this Agreement, if this Agreement is terminated  prior to the end  of the Initial Term or any subsequent Renewal Term, Client shall pay Staffy a termination fee equal to the greater of (x) all Monies Owed for the 6 completed months immediately prior to termination and (y) $10,000.',
            '\n',
            'd) If the client agrees to a preferred vendor agreement, the client shall give Staffy 24 hours to find appropriate workers for any and every given shift, or series of shifts, after which, the client shall be allowed to seek assistance from other entities.',
            '\n',
            'e) If the client agrees to a preferred vendor agreement, the client shall have in place, a written policy that details how the client intends to give Staffy priority access to all shifts, and a mechanism by which they can do the same.',
            '\n', {
            text: '11) Notice. ',
            style: 'bolder'
        },
            '\n',
            'Communications relating to Service Requests shall be sent in accordance with Section 1. All other communications under this Agreement shall be given in writing and may be given by personal delivery, regular mail, or email. Any Notice given by personal delivery will be deemed to have been received on the day of actual delivery, by regular mail on the 3rd business day following posting, and if delivered by email on the next business day after transmittal. Either party may change the addresses or contact information set out in this agreement by notice in writing to the other party sent in accordance with this Section 10.',
            '\n', {
            text: '12) Miscellaneous.',
            style: 'bolder'
        },
            '\n',
            'f)	Provisions of this Agreement, which by their terms extend beyond the termination or non renewal of this Agreement, will remain effective after termination or non renewal.',
            '\n',
            'g)	No provision of this Agreement may be amended or waived unless agreed to in a writing signed by the parties. However, Staffy reserves the right to increase   the   administrative   fee   set out in paragraph 4(b) herein upon 30 days written notice to the Client, in which case Client may terminate this Agreement subject to any applicable early termination fees.',
            '\n',
            'h)	Each provision of this Agreement will be considered severable, such that if any one provision or clause conflicts with existing or future applicable law or may not be given full effect because of such law, no other provision that can operate without the conflicting provision or clause will be affected.',
            '\n',
            'i)	This Agreement contains the entire understanding between the parties and supersede all prior agreements and understandings relating to the subject matter of the Agreement.',
            '\n',
            'j)	The provisions of this Agreement will inure to the benefit of and be binding on the parties and their respective representatives, successors, and assigns.',
            '\n',
            'k) The failure of a party to enforce the provisions of this Agreement will not be interpreted as a waiver of any provision or the right of such party thereafter to enforce each and every provision of this Agreement.',
            '\n',
            'l) Client will not transfer or assign this Agreement without Staffy’s prior written consent.',
            '\n',
            'm) Neither party will be responsible for failure or delay in performance of this Agreement if the failure or delay is due to fire, riot, war, terrorism, acts of God, or any other causes beyond the control of the non performing party.',
            '\n',
            'n)This validity, performance, construction and interpretation of this Agreement shall be governed by the laws of the province of Ontario and the laws of Canada applicable therein, save and except with respect to conflict of laws principles.',
            '\n',
            'Authorized representatives of the parties have executed this Agreement below to express the parties\' agreement to its terms.',
            '\n',
        'Contract was signed on ' + dateStafferAgree + ' from ' + (user.ip ? user.ip : 'undetected') + ' IP address',
        '\n',
        '\n',
        // {
        //     text: 'SCHEDULE “A”',
        //     style: 'bolder'
        // }, {
        //     text: 'SERVICES and FEES',
        //     style: 'bolder'
        // },
        // '\n',
        // '[Add details of the positions covered, rates, schedules etc.]',
        // '\n', {
        //         table: {
        //             // headers are automatically repeated if the table spans over multiple pages
        //             // you can declare how many rows should be treated as headers
        //             // headerRows: 1,
        //             widths: [ '*', 'auto', 'auto', 'auto', 'auto' ],
            
        //             body: [
        //                 [ 'Role', 'Min', 'Max', 'Min with default service fee (35%)', 'Max with default service fee (35%)' ],
        //                 [ 'Kitchen', '', '', '', '' ],
        //                 [ 'Cook Helper', '$16.00', '$20.00', '$21.60', '$27.00' ],
        //                 [ 'Cook', '$17.50', '$22.50', '$23.63', '$30.38' ],
        //                 [ 'Kitchen manager/ Chef', '$25.00', '$35.00', '$33.75', '$47.25' ],
        //                 [ 'Dishwasher', '$16.00 ', '$20.00', '$21.60', '$27.00' ],
        //                 [ 'Healthcare', '', '', '', '' ],
        //                 [ 'RPN', '$35.00 ', '$50.00', '$47.25', '$67.50' ],
        //                 [ 'PSW', '$22.00 ', '$35.00', '$29.70', '$47.2' ],
        //                 [ 'RN', '$50.00 ', '$70.00', '$67.50', '$94.50' ],
        //                 [ 'Janitorial', '$18.00 ', '$24.00', '$24.30', '$32.40' ],
        //                 [ 'Cleaner', '$18.00 ', '$24.00', '$24.30', '$32.40' ],
        //                 [ 'Room attendant', '$18.00 ', '$24.00', '$24.30', '$32.40' ],
        //                 [ 'Admin', '$20.00 ', '$30.00', '$27.00', '$40.50' ],
        //                 [ 'Dietary', '$18.00 ', '$27.00', '$24.30', '$36.45' ]
        //             ]
        //         }
        //     }
        ]
    }
    // For USA susers
    else {
        return [{
            text: 'Staffy, Inc. - General Staffing Agreement ',
            style: 'header'
        },
            '\n\n',
        'This general staffing agreement (the "Agreement") is entered into on the ' + dayEstAgree + ' day of ' + monthEstAgree + ' , ' + year + ' by and between Staffy, Inc., a corporation incorporated under the laws of Delaware ("Staffy"), and ' + companyName + ', a corporation incorporated under the laws of ' + companyName + ' (the "Client").',
            '\n\n', {
            text: 'WHEREAS: ',
            style: 'bolder'
        },
            '\n',
            'A. Client operates a restaurant, catering, staffing, or other food preparation and distribution service.',
            'B. Staffy provides resources, when and where possible, to help resolve temporary staffing issues.',
            'C. Client desires Staffy to provide staffing services on an as needed basis.',
            '\n', {
            text: 'NOW THEREFORE, Client and Staffy hereby agree as follows: ',
            style: 'bolder'
        },
            '\n', {
            text: '1) Services.',
            style: 'bolder'
        },
            '\n',
            ' Upon request by Client (a Service Request) Staffy shall assign temporary, supplemental personnel (the Staff) to Client in accordance with the terms and conditions in this Agreement. A Service Request shall include Client’s name, the service position required, approximate hours of work, the name and contact information for the contact person to which a reply to the Service Request is to be sent, and the name and address of the facility to which Staff is to report. All Service Requests shall be submitted by email or SMS (text), or, when available, the StaffyApp.',
            '\n', {
            text: '2) Staffy\'s Duties and Responsibilities.',
            style: 'bolder'
        },
            '\n',
            ' Staffy Shall:',
            '\n',
            'a)	maintain a pool of qualified Staff capable of providing the services ',
            '\n',
            'b)	use reasonable efforts to provide confirmation of receipt of a Service Request within 30 minutes of receiving such request from Client,',
            '\n',
            'c)	use reasonable efforts to provide notification of the assignment of Staff to perform the services requested in a Service Request, within 2 hours of receiving a Service Request, subject to availability of qualified Staff',
            '\n',
            'd)	make reasonable efforts to provide replacement personnel in the event the assigned Staff does not report to or perform the work requested,',
            '\n',
            'e)	be responsible for paying Staff, and',
            '\n',
            'f)	require each Staff to sign an independent contractor agreement with Staffy, acknowledging that they are not entitled to vacation, vacation pay, severance pay, disability benefits, insurance, pensions, retirement plans, or any other benefits offered or provided by Client to its employees.',
            '\n', {
            text: '3) Client\'s Duties and Responsibilities:',
            style: 'bolder'
        },
            '\n',
            ' Client Shall:',
            '\n',
            'a)	properly supervise Staff performing its Work and be responsible for its business, operations, products, services and intellectual property,',
            '\n',
            'b)	properly supervise, control and safeguard its premises, processes, and systems,',
            '\n',
            'c)	provide Staff with a safe work environment and provide appropriate information, training and safety equipment, as appropriate,',
            '\n',
            'd)	not change assigned Staff’s job duties without Staffy’s express prior written approval,',
            '\n',
            'e)	exclude Staff from Client’s benefit plans, policies, and practices, and not make any offer or promise relating to Staff’s compensation or benefits,',
            '\n',
            'f)	refrain from entrusting Staff with unattended premises, cash, checks, keys, credit cards, merchandise, confidential or trade secret information, negotiable instruments, or other valuables without Staffy’s express prior written approval or as strictly required by the job description provided to Staffy, and',
            '\n',
            'g)	refrain from using the services of any Staff as its direct employee, as an independent contractor, or through any person or firm other than Staffy during or within 6 months after the end of any assignment of the Staff to Client from Staffy, except with the prior written consent of Staffy and upon payment of the fee described in section 4(i) below.',
            '\n', {
            text: '4) Payment Terms, Bill Rates and Fees. ',
            style: 'bolder'
        },
            '\n',
            'a)	Client shall pay Staffy for all work completed by Staff (the "Completed Work") in accordance with the rates agreed upon, and will pay any additional costs or fees set forth in this Agreement (Cumulatively referred to as Monies Owed).',
            '\n',
            'b)	Client shall pay Staffy an administrative fee of:',
            '\n\n',
            'i) 30% on the total amount charged for Completed Work if Monies Owed are processed as set out in paragraphs (c) and (d) below;',
            '\n\n',
            'ii) 20% of the total amount charged for Completed Work if Monies Owed are processed as set out in paragraphs (c) and (d) below and Client executes an exclusivity agreement with Staffy; or',
            '\n\n',
            'iii) A percentage of the total amount charged for Completed Work that is higher than 30% if alternative payment arrangements are negotiated.',
            '\n\n',
            'c)	Client shall provide Staffy with a pre-authorized credit card to satisfy all Monies Owed to Staffy.',
            '\n',
            'd)	Staffy with charge all Monies Owed to the Client’s credit card within 48 hours of the Completed Work and a receipt for the same will be issued (the “Receipt”).',
            '\n',
            'e)	Any discrepancy or dispute related to the Receipt must be conveyed within 5 days of receiving the same.',
            '\n',
            'f)	 In the event the Monies Owed cannot be satisfied by the credit card provided, Staffy will contact the Client to provide another credit card. If another credit card is not immediately provided, or is provided and cannot satisfy the full amount of Monies Owed, the Client will be considered past due and a fee of 3% per month will be charged on the full amount of the Monies Owed until they are paid.',
            '\n',

            'g) Monies Owed will be supported by pertinent time sheets or other agreed upon records documenting time worked by Staff.',

            '\n',
            'h)	In the event Staffy fails to pay Monies Owed when due, or otherwise breaches its obligations under this Agreement, Staffy may, by notice to Client, suspend the provision of services to Client until such time as the breach is remedied to Staffy’s reasonable satisfaction. ',

            '\n',
            'i)	If Staffy consents to Client’s direct use of the services of any Staff as provided for in section 3(g) above, Client must pay Staffy an additional fee equal to 100 hours of service at the Staff’s regular hourly rate, or as otherwise negotiated. ',
            '\n',
            'j)	Client’s failure to comply with section 3(g) and/or the associated payment required by subsection (i) herein, shall constitute a breach of this Agreement and said breach will trigger a penalty, payable immediately upon such breach by Client to Staffy. Said penalty, which is in addition to the amounts due and owing under subsection (i) herein, shall be equal to 400 hours of service at the Staff’s regular hourly rate. In addition, upon such breach, Staffy reserves the right, in its sole discretion, to terminate or suspend the delivery of services under this Agreement. Client agrees that this penalty represents a fair, reasonable and appropriate estimate of damages.',
            '\n',
            'k)	If a pre-booked shift is cancelled within 48 hours of the shift start time, the Client may be subject to a three-hour cancellation fee.',
            '\n',
            'l)	The minimum length for any shift shall be 4 hours.',
            '\n', {
            text: '5) Confidential Information. ',
            style: 'bolder'
        },
            '\n',
            'Staffy and Client may receive non-public information that is proprietary or confidential information to the other party or its affiliated companies and their clients. Both parties agree to hold such information in strict confidence and not to disclose such information to third parties or to use such information for any purpose whatsoever other than performing under this Agreement or as required by law. No knowledge, possession, or use of Client’s confidential information will be imputed to Staffy as a result of Staff’s access to such information.',
            '\n', {
            text: '6) Nature of the Relationship. ',
            style: 'bolder'
        },
            '\n',
            'Staffy and Client are independent contractors. Nothing contained in this Agreement will be construed to create a relationship of partnership, principal and agent, or employer and employee, between Staffy and Client.',
            '\n', {
            text: '7) Marketing.',
            style: 'bolder'
        },
            '\n',
            'The client agrees to allow Staffy, Inc or its parent, Staffy Canada Inc. use of its logo, trade names and other service marks for purposes of cross-promotion and marketing',
            '\n', {
            text: '8) Cooperation.',
            style: 'bolder'
        },
            '\n',
            'Staffy and Client agree to cooperate fully and to provide assistance to the other party in the investigation and resolution of any complaints, claims, actions, or proceedings that may be brought by or that may involve Staff.',
            '\n', {
            text: '9) Indemnification and Limitation of Liability. ',
            style: 'bolder'
        },
            '\n',
            'a)	To the maximum extent permitted by law, Staffy will defend, indemnify, and hold Client and its parent, subsidiaries, directors, officers, agents, representatives, and employees harmless from all claims, losses, and liabilities (including reasonable lawyers’ fees) to the extent caused by Staffy’s breach of this Agreement, or the gross negligence or willful misconduct of Staffy or Staffy’s officers, employees or authorized agents in the discharge of those duties and responsibilities.',
            '\n',
            'b)	To the maximum extent permitted by law, Client will defend, indemnify, and hold Staffy and its parent, subsidiaries, directors, officers, agents, representatives, and employees harmless from all claims, losses, and liabilities (including reasonable lawyers’ fees) to the extent caused by Client’s breach of this Agreement, or the negligence, gross negligence, or willful misconduct of Client or Client’s officers, employees, or authorized agents in the discharge of those duties and responsibilities.',
            '\n',
            'c)	ALL WARRANTIES, CONDITIONS, REPRESENTATIONS, INDEMNITIES AND GUARANTEES, WHETHER EXPRESS OR IMPLIED, ARISING BY LAW, CUSTOM, PRIOR ORAL OR WRITTEN STATEMENTS BY STAFFY OR OTHERWISE (INCLUDING, BUT NOT LIMITED TO, ANY WARRANTY OF MERCHANT ABILITY OR FITNESS FOR PARTICULAR PURPOSE) ARE HEREBY OVERRIDDEN, EXCLUDED AND DISCLAIMED. STAFFY MAKES NO ASSURANCE AS TO THE RESULTS OF ITS SERVICES, AND STAFFY IS TO BE PAID FOR SERVICES RENDERED IRRESPECTIVE OF THE RESULTS OF SUCH SERVICES.',
            '\n',
            'd)	NEITHER PARTY SHALL BE LIABLE FOR OR BE REQUIRED TO INDEMNIFY THE OTHER PARTY FOR ANY INCIDENTAL, CONSEQUENTIAL, EXEMPLARY, SPECIAL, PUNITIVE, OR LOST PROFIT DAMAGES THAT ARISE IN CONNECTION WITH THIS AGREEMENT, REGARDLESS OF THE FORM OF ACTION (WHETHER IN CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, OR OTHERWISE) AND REGARDLESS OF HOW CHARACTERIZED, EVEN IF SUCH PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE MAXIMUM LIABILITY OF EITHER PARTY UNDER THIS AGREEMENT SHALL NOT EXCEED THE FEES PAID BY CLIENT UNDER THIS AGREEMENT DURING THE 6 MONTH PERIOD PRECEDING THE OCCURRENCE OF THE EVENT GIVING RISE TO SUCH LIABILITY.',
            '\n',
            'e)	As a condition precedent to indemnification, the party seeking indemnification will inform the other party within 2 business days after it receives notice of any claim, loss, liability, or demand for which it seeks indemnification from the other party; and the party seeking indemnification will cooperate in the investigation and defense of any such matter.',
            '\n', {
            text: '10) Term of Agreement.',
            style: 'bolder'
        },
            '\n',
            'This Agreement will be for a term of 12 months from the first date on which both parties have executed it. The Agreement may be terminated by either party upon 15 days’ written notice to the other party, except that, if  a party becomes bankrupt or insolvent, discontinues operations, or fails to make any payments as required by the Agreement, either party may terminate the agreement upon 72 hours written notice. Unless the Agreement is cancelled or a renegotiation notice is sent 30 days prior to the Agreement’s expiration date, the Agreement will be renewed automatically upon expiration for an additional 12 month term. Termination of this Agreement shall not be effective with respect to any placed Staff until their placements are terminated or cease.',
            '\n', {
            text: '11) Notice. ',
            style: 'bolder'
        },
            '\n',
            'Communications relating to Service Requests shall be sent in accordance with Section 1. All other communications under this Agreement shall be given in writing and may be given by personal delivery, regular mail, or email. Any Notice given by personal delivery will be deemed to have been received on the day of actual delivery, by regular mail on the 3rd business day following posting, and if delivered by email on the next business day after transmittal. Either party may change the addresses or contact information set out in this agreement by notice in writing to the other party sent in accordance with this Section 10.',
            '\n', {
            text: '12) Miscellaneous.',
            style: 'bolder'
        },
            '\n',
            'a)	Provisions of this Agreement, which by their terms extend beyond the termination or nonrenewal of this Agreement, will remain effective after termination or nonrenewal.',
            '\n',
            'b)	No provision of this Agreement may be amended or waived unless agreed to in a writing signed by the parties.',
            '\n',
            'c)	Each provision of this Agreement will be considered severable, such that if any one provision or clause conflicts with existing or future applicable law or may not be given full effect because of such law, no other provision that can operate without the conflicting provision or clause will be affected.',
            '\n',
            'd)	This Agreement contains the entire understanding between the parties and supersede all prior agreements and understandings relating to the subject matter of the Agreement.',
            '\n',
            'e)	The provisions of this Agreement will inure to the benefit of and be binding on the parties and their respective representatives, successors, and assigns.',
            '\n',
            'f)	The failure of a party to enforce the provisions of this Agreement will not be interpreted as a waiver of any provision or the right of such party thereafter to enforce each and every provision of this Agreement.',
            '\n',
            'g)	Client will not transfer or assign this Agreement without Staffy’s prior written consent.',
            '\n',
            'h)	Neither party will be responsible for failure or delay in performance of this Agreement if the failure or delay is due to fire, riot, war, terrorism, acts of God, or any other causes beyond the control of the nonperforming party.',
            '\n',
            'i)	This validity, performance, construction and interpretation of this Agreement shall be governed by the province of Ontario and the laws of Canada.',
            '\n',
            'Authorized representatives of the parties have executed this Agreement below to express the parties\' agreement to its terms.',
            '\n',
        'Contract was signed on ' + dateStafferAgree + ' from ' + (user.ip ? user.ip : 'undetected') + ' IP address'
        ]
    }
}




export function getStateAndCity(city) {

    const cities = {
        Calgary: { country: 'Canada', state: 'Alberta' },
        Edmonton: { country: 'Canada', state: 'Alberta' },
        
        Halifax: {country:'Canada', state: 'Nova Scotia'},
        Lunenburg: {country:'Canada', state: 'Nova Scotia'},
        Yarmouth: {country:'Canada', state: 'Nova Scotia'},
        Wolfville: {country:'Canada', state: 'Nova Scotia'},
        Annapolis_Royal: {country:'Canada', state: 'Nova Scotia'},
        New_Glasgow: {country:'Canada', state: 'Nova Scotia'},
        Truro: {country:'Canada', state: 'Nova Scotia'},
        Antigonish: {country:'Canada', state: 'Nova Scotia'},
        Amherst: {country:'Canada', state: 'Nova Scotia'},
        Baddeck: {country:'Canada', state: 'Nova Scotia'},
        Kentville: {country:'Canada', state: 'Nova Scotia'},
        Shelburne: {country:'Canada', state: 'Nova Scotia'},
        Mahone_Bay: {country:'Canada', state: 'Nova Scotia'},
        Tatamagouche: {country:'Canada', state: 'Nova Scotia'},
        Bridgewater: {country:'Canada', state: 'Nova Scotia'},
        Chester: {country:'Canada', state: 'Nova Scotia'},
        Middleton: {country:'Canada', state: 'Nova Scotia'},
        Pictou: {country:'Canada', state: 'Nova Scotia'},
        Parrsboro: {country:'Canada', state: 'Nova Scotia'},
        Digby: {country:'Canada', state: 'Nova Scotia'},
        Dartmouth: {country:'Canada', state: 'Nova Scotia'},
        Greenwood: {country:'Canada', state: 'Nova Scotia'},
        Berwick: {country:'Canada', state: 'Nova Scotia'},
        Port_Hawkesbury: {country:'Canada', state: 'Nova Scotia'},
        Liverpool: {country:'Canada', state: 'Nova Scotia'},
        Argyle: {country:'Canada', state: 'Nova Scotia'},
        Cornwallis_Square: {country:'Canada', state: 'Nova Scotia'},

        Hamilton: { country: 'Canada', state: 'Ontario' },
        Kitchener: { country: 'Canada', state: 'Ontario' },
        Mississauga: { country: 'Canada', state: 'Ontario' },
        Montreal: { country: 'Canada', state: 'Québec' },
        Ottawa: { country: 'Canada', state: '' },
        Quebec: { country: 'Canada', state: '' },
        Toronto: { country: 'Canada', state: '' },
        Vancouver: { country: 'Canada', state: '' },
        Winnipeg: { country: 'Canada', state: '' },
        Newark: { country: 'United States', state: 'New Jersey' },
        Jersey_City: { country: 'United States', state: 'New Jersey' },
        Rochester: { country: 'United States', state: 'New York' },
        Albuquerque: { country: 'United States', state: 'New Mexico' },
        Atlanta: { country: 'United States', state: 'Georgia' },
        Austin: { country: 'United States', state: 'Texas' },
        Baltimore: { country: 'United States', state: 'Maryland' },
        Boston: { country: 'United States', state: 'Massachusetts' },

        Charlotte: { country: 'United States', state: 'North Carolina' },
        Chicago: { country: 'United States', state: 'Illinois' },
        Cleveland: { country: 'United States', state: 'Ohio' },
        Colorado_Springs: { country: 'United States', state: 'Colorado' },
        Columbus: { country: 'United States', state: 'Ohio' },
        Dallas: { country: 'United States', state: 'Texas' },
        Denver: { country: 'United States', state: 'Colorado' },
        Detroit: { country: 'United States', state: 'Michigan' },

        El_Paso: { country: 'United States', state: 'Texas' },
        Fort_Worth: { country: 'United States', state: 'Texas' },
        Fresno: { country: 'United States', state: 'California' },

        Houston: { country: 'United States', state: 'Texas' },
        Indianapolis: { country: 'United States', state: 'Indiana' },
        Jacksonville: { country: 'United States', state: 'Florida' },
        Kansas_City: { country: 'United States', state: 'Missouri' },
        Las_Vegas: { country: 'United States', state: 'Nevada' },
        Long_Beach: { country: 'United States', state: 'California' },
        Los_Angeles: { country: 'United States', state: 'California' },
        Louisville: { country: 'United States', state: 'Kentucky' },
        Memphis: { country: 'United States', state: 'Tennessee' },
        Mesa: { country: 'United States', state: 'Arizona' },
        Miami: { country: 'United States', state: 'Florida' },
        Milwaukee: { country: 'United States', state: 'Wisconsin' },
        Minneapolis: { country: 'United States', state: 'Minnesota' },
        Nashville: { country: 'United States', state: 'Tennessee' },
        New_York: { country: 'United States', state: 'New York' },
        New_Jersey: { country: 'United States', state: 'New Jersey' },
        New_Orleans: { country: 'United States', state: 'Louisiana' },
        Oakland: { country: 'United States', state: 'California' },
        Oklahoma_City: { country: 'United States', state: 'Oklahoma' },
        Omaha: { country: 'United States', state: 'Nebraska' },

        Philadelphia: { country: 'United States', state: 'Pennsylvania ' },
        Phoenix: { country: 'United States', state: 'Arizona' },
        Portland: { country: 'United States', state: 'Oregon' },
        Raleigh: { country: 'United States', state: 'North Carolina' },
        Sacramento: { country: 'United States', state: 'California ' },
        San_Antonio: { country: 'United States', state: 'Texas' },
        San_Diego: { country: 'United States', state: 'California' },
        San_Francisco: { country: 'United States', state: 'California' },
        San_Jose: { country: 'United States', state: 'California' },
        Seattle: { country: 'United States', state: 'Washington' },
        Tucson: { country: 'United States', state: 'Arizona' },
        Tulsa: { country: 'United States', state: 'Oklahoma' },
        Virginia_Beach: { country: 'United States', state: 'Virginia' },
        Washington: { country: 'United States', state: 'District of Columbia' },
        Wichita: { country: 'United States', state: '' },
    }
    return typeof (cities[city]) == 'undefined' ? { country: '', state: '' } : cities[city];
}

export function findCountryFromState(state) {

    const getCountry = {
        // USA
        'Alabama': { country: 'United States' },
        'Alaska': { country: 'United States' },
        'Arizona': { country: 'United States' },
        'Arkansas': { country: 'United States' },
        'California': { country: 'United States' },
        'Colorado': { country: 'United States' },
        'Connecticut': { country: 'United States' },
        'Delaware': { country: 'United States' },
        'Florida': { country: 'United States' },
        'Georgia': { country: 'United States' },
        'Hawaii': { country: 'United States' },
        'Idaho': { country: 'United States' },
        'Illinois': { country: 'United States' },
        'Indiana': { country: 'United States' },
        'Iowa': { country: 'United States' },
        'Kansas': { country: 'United States' },
        'Kentucky': { country: 'United States' },
        'Louisiana': { country: 'United States' },
        'Maine': { country: 'United States' },
        'Maryland': { country: 'United States' },
        'Massachusetts': { country: 'United States' },
        'Michigan': { country: 'United States' },
        'Minnesota': { country: 'United States' },
        'Mississippi': { country: 'United States' },
        'Missouri': { country: 'United States' },
        'Montana': { country: 'United States' },
        'Nebraska': { country: 'United States' },
        'Nevada': { country: 'United States' },
        'New_Hampshire': { country: 'United States' },
        'New_Jersey': { country: 'United States' },
        'New_Mexico': { country: 'United States' },
        'New_York': { country: 'United States' },
        'North_Carolina': { country: 'United States' },
        'North_Dakota': { country: 'United States' },
        'Ohio': { country: 'United States' },
        'Oklahoma': { country: 'United States' },
        'Oregon': { country: 'United States' },
        'Pennsylvania': { country: 'United States' },
        'Rhode_Island': { country: 'United States' },
        'South_Carolina': { country: 'United States' },
        'South_Dakota': { country: 'United States' },
        'Tennessee': { country: 'United States' },
        'Texas': { country: 'United States' },
        'Utah': { country: 'United States' },
        'Vermont': { country: 'United States' },
        'Virginia': { country: 'United States' },
        'Washington': { country: 'United States' },
        'West_Virginia': { country: 'United States' },
        'Wisconsin': { country: 'United States' },
        'Wyoming': { country: 'United States' },

        // CANADA
        'Alberta': { country: 'Canada' },
        'British_Columbia': { country: 'Canada' },
        'Labrador': { country: 'Canada' },
        'Manitoba': { country: 'Canada' },
        'New_Brunswick': { country: 'Canada' },
        'Newfoundland': { country: 'Canada' },
        'Nova_Scotia': { country: 'Canada' },
        'Nunavut': { country: 'Canada' },
        'North_West_Terr': { country: 'Canada' },
        'Ontario': { country: 'Canada' },
        'Prince_Edward_Is': { country: 'Canada' },
        'Quebec': { country: 'Canada' },
        'Saskatchewen': { country: 'Canada' },
        'Yukon': { country: 'Canada' }
    }

    return typeof (getCountry[state]) == "undefined" ? 'Canada' : getCountry[state].country;
}

export const businessCotractEmailStyle =
{
    header: {
        fontSize: 18,
        bold: true
    },
    subheader: {
        fontSize: 15,
        bold: true
    },
    bolder: {
        fontSize: 13,
        bold: true
    },
    boldest: {
        fontSize: 16,
        bold: true
    },
    quote: {
        italics: true
    },
    small: {
        fontSize: 8
    }
}
